import * as actions from './actions'
import reducer from './reducer'
import CriarCustomForm from './components/CriarCustomForm'
import * as TypeAction from './actionTypes'



const config = {
    route: {
        path: '/ElaborarFormulario',
        exact: true,
        component: CriarCustomForm,
        permissao: "Personalizar.Elaborar Formulário"
    },
    menu: { nome: "Elaborar Formulário", rota: '/ElaborarFormulario', ordem: 900, subDe: "Personalizar", permissao: "Personalizar.Elaborar Formulário" },
    reducerConfig: { nome: "CriarCustomFormReducer", reducer: reducer }

}

export default config


export { actions, reducer, TypeAction }




// WEBPACK FOOTER //
// ./src/routes/sistema/CriarCustomForm/index.js